import children from '../children';

const FORWARD = 1;
const BACKWARD = -1;

const getPath = (vueInstance, path) => `/submission/${vueInstance.$route.params.videoId}/${path}`;
const predictPath = (vueInstance, index) => {
  const pathName = getPath(vueInstance, index);
  return (vueInstance.$router.resolve(pathName).route.matched.length) ? pathName : null;
};

const pageNavigationMixin = {
  computed: {
    currentPage() {
      const currentPath = this.$route.path;
      return parseInt(currentPath.split('/').splice(-1)[0], 10);
    },
    hasPrev() {
      return this.currentPage > 1;
    },
    hasNext() {
      return this.currentPage < children.length;
    },
  },
  methods: {
    previousSection() {
      const problem = this.prev();
      if (problem == null) this.go(this.currentPage + BACKWARD);
      else this.$notify.error(problem);
    },
    nextSection() {
      const problem = this.next();
      if (problem == null) this.go(this.currentPage + FORWARD);
      else this.$notify.error(problem);
    },

    go(pathIndex) {
      const path = predictPath(this, pathIndex);
      if (path) this.$router.push(path);
    },
  },
  created() {
    this.children = children;
  },
};

export default pageNavigationMixin;



// WEBPACK FOOTER //
// ./src/components/Submission/Mixins/pageNavigationMixin.js